export const COMPLETED_TRANSACTION_STATUSES = [
  'completed',
  'ready',
  'refunded',
  'partially_refunded'
];
